// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, ellipsis, hideElementOnPrint } from "@turnerBlueprint/XDL/Utilities";
import { styledBoxStyles } from "@turnerScienceBlueprint/App/Widgets/StyledBox/StyledBox";
import { css } from "styled-components";

styledBoxStyles.container = {
    css: css`
        height: 100%;
        background-color: ${color("common.ui2")};
        display: flex;
        flex-direction: column;
        box-shadow: inset 0 6px 0 0 ${color("common.ui9")};
        padding: 16px;
        align-items: flex-start;
        ${hideElementOnPrint}
        ${({ backgroundColor }: any) =>
            css`
                background-color: ${backgroundColor};
            `}
    `,
};

styledBoxStyles.titleTypography = {
    variant: "h3",
    css: css`
        ${({ titleColor }: any) =>
            css`
                color: ${titleColor};
            `}
    `,
};

styledBoxStyles.descriptionTypography = {
    css: css`
        flex-grow: 1;
        margin-bottom: 20px;
        font-size: 14px;
        line-height: 22px;
        color: ${color("text")};

        ${({ maxNumberOfDescriptionLines, descriptionColor }: any) =>
            css`
                ${ellipsis(maxNumberOfDescriptionLines)};
                color: ${descriptionColor};
            `}
    `,
};

styledBoxStyles.action = {
    variant: "primary",
    css: css`
        margin-bottom: 12px;
    `,
};
